<template>
  <div class="container">
    <div class="featured-categories" :style="paddingStyles">
      <div class="row">
        <div class="column column_first">
          <div class="featured-categories__header-container">
            <p class="preheader featured-categories__preheading" v-if="featuredCategories.preHeading"
              :class="featuredCategories.textColor">{{ featuredCategories.preHeading }}</p>

            <div style="display:hidden;"></div><!-- to make the heading center-->
            <h2 class="h2 " v-if="featuredCategories.heading" :class="featuredCategories.headingColor"
              v-html="featuredCategories.heading" />
            <h3 class="subheader featured-categories__subheading" v-if="featuredCategories.subHeading"
              :class="featuredCategories.textColor">{{ featuredCategories.subHeading }}</h3>
            <v-link class="link link--secondary featured-categories__view-all-button link"
              href="/blogs/all" v-if="featuredCategories.enableCta">
              <svg xmlns="http://www.w3.org/2000/svg" width="60px" viewBox="0 0 350 100">
                <defs>
                  <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
                    <polygon points="0 0, 10 3.5, 0 7" />
                  </marker>
                </defs>
                <line x1="0" y1="50" x2="250" y2="50" stroke="#000" stroke-width="8" marker-end="url(#arrowhead)" />
              </svg>
              Visit Blog
            </v-link>

          </div>
        </div>
        <div class="column column_second">
          <div class="featured-categories__categories">
            <a class="featured-categories__category" v-for="(category, index) in featuredCategories.categories"
              :href="category.categoryUrl" :key="index" :class="featuredCategories.textColor"
              :aria-label="category.categoryName">
              <div>
                <div class="featured-categories__image" data-clip-img="data-clip-img"
                  :style="{ backgroundImage: `url('${category.featuredImg}')` }"></div>
                <h3 class="h6 featured-categories__title">{{ category.categoryName }}</h3>
                <p v-if="category.categoryDescription"
                  class="body-sm-mobile body-sm-tablet-up featured-categories__description">
                  {{ category.categoryDescription }}</p>
                <v-link class="featured-articles__read-more link link--primary blog-link">Read More</v-link>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'
import css from 'swiper/swiper-bundle.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import VButton from '@/scripts/components/buttons/VButton.vue'
import ArrowButton from '@/scripts/components/buttons/ArrowButton.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'
import LinkButton from '@/scripts/components/buttons/LinkButton.vue'
import { px } from '@/scripts/filters/string.js'
import { checkUndefined } from '@/scripts/helpers/util.js'

export default {
  name: 'BlogSectionCategoriesStatic',
  components: {
    swiper,
    swiperSlide,
    ArrowButton,
    Icon,
    VButton,
    LinkButton,
    VLink
  },
  props: {
    featuredCategories: {
      type: Object,
      default: () => ({
        layout: String,
        bgColor: String,
        headingColor: String,
        textColor: String,
        preHeading: String,
        heading: String,
        subHeading: String,
        enableCta: Boolean,
        ctaLayout: String,
        categories: {
          type: Array,
          default: () => ([{
            categoryName: String,
            categoryUrl: String,
            categoryDescription: String,
            featuredImg: String
          }])
        }
      })
    }
  },
  data() {
    return {
      mobileOptions: {
        slidesPerView: 3,
        spaceBetween: 60,
        loop: true,
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 60
          },
          1280: {
            slidesPerView: 3
          }
        }
      },
      currentIndex: 0
    }
  },
  computed: {
    swiper() {
      return this.$refs.blogSectionMobile.swiper
    },
    paddingStyles() {
      if (this.$mq !== 'mobile') {
        return {
          'padding-top': '0px',
          'padding-bottom': '10px'
        }
      } else {
        return {
          'padding-top': '5px',
          'padding-bottom': '5px'
        }
      }
    }
  },
  methods: {
    slidePagination(index) {
      this.swiper.slideToLoop(index)
    },
    dotActive(index) {
      if (this.currentIndex === index) {
        return 'active'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;

}

.column_first {
  flex: 1;
  justify-content: center;
}

.column_second {
  flex: 3;
}

.blog-link {
  line-height: 23px;
  font-size: 1rem;
  font-family: $font-family-secondary !important;

  &:not(.link--disabled):after {
    content: inherit !important;
  }
}

.container {
  max-width: 1100px;
  @include mobile-only {
    padding-right: 0;
    padding-left: 12px;
  }
}

.featured-categories {
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  &__preheading {
    text-align: center;
    text-transform: initial;

    @include mobile-only {
      margin-bottom: 4px;
    }
  }

  &__header-container {
    width: 100%;
    max-width: 1200px;

    @media (max-width: 1313px) {
      display: contents;
    }
    h2 {
      font-size: 3.2rem;
      line-height: 120%;
    }
  }

  &__heading {
    text-align: left;
    text-transform: initial;
    line-height: 110%;
    max-width: 327px;
    font-family: 'Ginkgo-Light';
    font-size: 75px;


    @include tablet-up {
      max-width: 762px;
    }

    @include mobile-only {
      line-height: 100%;
    }
  }

  &__subheading {
    text-align: left;
    text-transform: initial;
    margin: 20px auto 25px auto;

    @include mobile-only {
      margin: 4px 0 0 0;
    }
  }

  &__categories {
    width: 100%;
    margin-top: 32px;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    max-width: 100%;
    margin: 0 auto;

    @include mobile-only {
      grid-auto-flow: row;
    }

    &--mobile {
      margin-top: 15px;
      margin-bottom: 24px;
      width: auto;
    }
  }

  &__category {
    text-decoration: none;
    margin: 5px;
    text-align: left;
    max-width: 300px;

    @include mobile-only {
      max-width: unset;
      width: 100%;
    }

    &:last-child {
      margin-bottom: 0;
    }

    @media (max-width: 1313px) {
      text-align: left;
    }

    h5 {
      margin-bottom: 8px;
    }

    p {
      margin-top: 0;
    }
  }

  &__image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-bottom: 10px;
    height: 22vw;
    width: 100%;
    max-height: 300px;
    max-width: 300px;

    @include mobile-only {
      max-height: unset;
      max-width: unset;
      height: 92vw;
      width: 92vw;
    }
  }

  &__cta-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 250px;
  }

  &__categories-mobile {
    width: 100%;
    margin: 0 auto;
    display: flex;
    overflow: scroll;
  }

  &__view-all-button {
    right: 0px;
    justify-self: end;
    text-transform: uppercase;
    font-weight: 400;

    @include mobile-only {
      margin-top: 10px;
    }

    &__desktop {
      @media (max-width: 1313px) {
        display: none;
      }
    }

    &__mobile {
      display: none;

      @media (max-width: 1313px) {
        margin: 52px 0 0;
        display: block;
      }
    }
  }

  &__read-more {
    overflow: inherit;
    text-decoration: none;

    .icon--arrow-right {
      margin-left: 6.5px;
    }
  }

  &__description {
    margin-top: 0;
    margin-bottom: 4px;
  }
}

h5 {
  margin: 0;

  @include tablet-up {
    margin: 0 0 24px 0;
  }
}

p {
  margin: 16px 0;
}

.controls-container {
  display: flex;
  position: absolute;
  bottom: 124px;
  width: 100%;
  z-index: 5;

  @include mobile-only {
    justify-content: center;
  }

  .pagination-dots {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 auto;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background-color: $color-grey;
    margin: 4px;
  }

  .dot.active {
    background-color: $color-off-black;
  }

  &.controls-no-cta {
    bottom: 48px;
  }
}

/deep/ .swiper-container {
  width: 100%;
  margin-right: 0;
  display: block;

  @include mobile-only {
    width: 96%;
  }

  @include hd-up {
    display: none;
  }

  p {
    @include mobile-only {
      min-width: 181px
    }
  }
}
</style>
